import React, { useState } from 'react';
import styles from '../../Recurring.module.css';

const faqData = [
  {
    q: 'What can I bill on a recurring basis?',
    a: 'Anything that repeats — retainers, subscriptions, memberships, payment plans, or regular service fees. Set the amount and cadence once and it runs on its own.',
  },
  {
    q: 'Can I pause or cancel a schedule?',
    a: 'Yes. Turn any recurring schedule off and back on without deleting it — the invoice and its history stay intact, so you never have to rebuild it.',
  },
  {
    q: 'How are customers charged each cycle?',
    a: 'Repeat customers can save a payment method to be charged automatically, or receive a fresh invoice with a Pay Now button each cycle — your choice.',
  },
  {
    q: 'Can I change the amount or schedule later?',
    a: 'Anytime. Edit the amount, cadence, recipients, or end date, and the changes apply to upcoming cycles.',
  },
  {
    q: 'Is recurring billing included?',
    a: "Recurring billing is part of Fyntiq Business. See the Pricing page for what's included on each plan.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Recurring questions.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div className={styles.faqQ} onClick={() => setOpenIndex(openIndex === i ? -1 : i)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}>
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
